import { isWalletUserCancellationMessage } from '@/domain/wallet/walletSigningFlow'
import { nutrimaticLabels } from '@/nutrimatic'

export type LiquidityMobileScreen = 'form' | 'review' | 'success' | 'cancelled' | 'error'

export function isLiquidityWalletCancellationMessage(message: string | null | undefined): boolean {
  if (!message) return false
  if (isWalletUserCancellationMessage(message)) return true
  return message === nutrimaticLabels.mobileSimple.liquidityOperationCancelled
}

export function resolveLiquidityMobileScreen({
  txHash,
  walletErrorMessage,
  showConfirm,
  attemptingTxn,
}: {
  txHash: string
  walletErrorMessage: string | null
  showConfirm: boolean
  attemptingTxn: boolean
}): LiquidityMobileScreen {
  if (txHash) return 'success'
  if (walletErrorMessage) {
    return isLiquidityWalletCancellationMessage(walletErrorMessage) ? 'cancelled' : 'error'
  }
  if (showConfirm || attemptingTxn) return 'review'
  return 'form'
}
